<template>
  <div class="answer-box">
    <div
      :class="[
        'answer-box__options',
        center ? 'answer-box__options--center' : '',
        right ? 'answer-box__options--right' : '',
        type == 'image' || type == 'video' ? 'answer-box__options--images' : ''
      ]"
    >
      <div
        v-for="(value, index) in values"
        :key="index"
        @click="toggleOption(type, value, index)"
        :class="[
          type == 'text' ? 'answer-box__option' : '',
          type == 'image' || type == 'video' ? 'answer-box__image' : '',
          type == 'video' ? 'answer-box__video' : ''
        ]"
      >
        {{ type == "text" ? value : "" }}
        <img v-if="type == 'image'" :src="value" alt="Akan SMB" />
        <img v-if="type == 'video'" :src="value.cover" alt="Akan SMB" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerBox",
  props: {
    values: Array,
    type: String,
    center: Boolean,
    right: Boolean,
    additionalScript: Object,
    answerKey: String,
    parentId: String,
    saveAnswer: Boolean,
    childIds: Array,
  },
  data() {
    return {
      selected: "",
      lastAnswer: false
    };
  },
  computed: {
    chat() {
      return this.$store.getters.getChatById(this.$route.params.id);
    }
  },
  methods: {
    toggleOption(type, value, index) {
      if (type == "text") {
        this.toggleTextOption(value, index);
      } else if (type == "image" || type == "video") {
        this.toggleImageOption(value, index);
      }
    },
    answerToQuestion(index) {
      let additionalScript = {};

      if (Object.keys(this.additionalScript).length) {
        additionalScript = this.additionalScript.A;

        if (this.values[1] == this.selected) {
          additionalScript = this.additionalScript.B;
        }
      }

      this.$store.dispatch("insertAnswer", {
        chatId: this.$route.params.id,
        value: this.selected,
        type: this.type,
        answerKey: this.childIds[index],
        parentId: this.parentId,
        additionalScript: additionalScript,
        phone_number: this.$route.params.phone_number,
        device_id: this.$store.getters.getDeviceId(),
        saveAnswer: this.saveAnswer,
      });
      this.$changePageContent(false, this.chat);
      this.$processMessages(this.chat.script, this.chat, this.$store);
    },
    toggleTextOption(answer, index) {
      let selected = this.selected != answer ? answer : "";
      const options = document.querySelectorAll(".answer-box__option");
      options.forEach(el =>
        el.innerText == selected
          ? el.classList.add("answer-box__option--selected")
          : el.classList.remove("answer-box__option--selected")
      );
      this.selected = selected;
      this.answerToQuestion(index);
    },
    toggleImageOption(image, index) {
      let selected = this.selected != image ? image : "";
      const options = document.querySelectorAll(".answer-box__image");

      options.forEach(el =>
        el.querySelector("img").attributes.src.value == selected
          ? el.classList.add("answer-box__image--selected")
          : el.classList.remove("answer-box__image--selected")
      );
      this.selected = selected;

      if (this.selected) {
        document
          .querySelector(".answer-box__options")
          .classList.add("answer-box__options--selected");
      } else {
        document
          .querySelector(".answer-box__options")
          .classList.remove("answer-box__options--selected");
      }

      this.answerToQuestion(index);
    }
  },
  mounted() {
    this.$changePageContent(true, this.chat);
  }
};
</script>

<style lang="scss">
.answer-box {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  transform: translateX(-50%);
  background-color: $color-bg-answer-box;
  max-width: 520px;
  position: fixed;
  z-index: 100;
  width: 100%;
  bottom: 0;
  left: 50%;

  &__options {
    padding: 20px 15px 15px 15px;
    align-items: flex-start;
    flex-direction: column;
    display: flex;
    width: 100%;

    &--center {
      align-items: center;
    }

    &--right {
      align-items: flex-end;
    }

    &--images {
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: row;
      flex-wrap: wrap;
    }

    &--selected {
      .answer-box__image {
        opacity: 0.6;

        &--selected {
          opacity: 1;
        }
      }
    }
  }

  &__option {
    border: 1px solid $color-primary;
    color: $color-primary-dark;
    border-radius: 99999px;
    letter-spacing: 0.36px;
    display: inline-block;
    margin-bottom: 10px;
    padding: 10px 15px;
    line-height: 1.56;
    font-size: 9px;

    @media #{$bigger-mobile} {
      font-size: 11px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &--selected {
      background-color: $color-primary;
      color: $txt-color-alt;
    }
  }

  &__image {
    box-shadow: 0px 3px 13px 0 rgba(0, 0, 0, 0.1);
    width: calc(50% - 8px);
    vertical-align: middle;
    display: inline-block;
    margin-right: 16px;
    position: relative;

    &:after {
      content: "";
      padding-bottom: 60%;
      display: block;
    }

    &:nth-of-type(even) {
      margin-right: 0;
    }

    img,
    svg {
      border-radius: 8px;
      position: absolute;
      object-fit: cover;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }

    &--selected {
      &:before {
        content: "";
        background-color: $color-primary;
        background-image: url("../assets/images/checked.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 8px;
        border-radius: 99999px;
        position: absolute;
        height: 20px;
        width: 20px;
        z-index: 1;
        left: -6px;
        top: -6px;
      }
    }
  }

  &__video {
    &:before {
      content: "";
      background: url(/img/play.42103e76.svg) no-repeat center;
      transform: translate(-50%, -50%);
      background-size: cover;
      position: absolute;
      font-size: 0;
      height: 45px;
      width: 45px;
      z-index: 1;
      left: 50%;
      top: 50%;
    }
  }

  &__submit {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding: 15px;
  }
}
</style>
